import React from 'react';
import PropTypes from 'prop-types';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import { withStyles } from '@material-ui/core/styles'
function doNothing(e) { console.log(`doNothing:`, e); }
const styles = {
  root: {
    width: '100%',
  },
  title: {
    flex: 1
  },
  leftIcon: {
    marginLeft: 0,
    marginRight: 20
  }
}
const AppBarComponent = props => {
  const { classes } = props;
  return (
    <AppBar position="absolute" className={classes.root}>
      <Toolbar>
        <IconButton
          onClick={props.onLeftButtonClick ? props.onLeftButtonClick : doNothing}
          className={classes.leftIcon}
          color="inherit"
          aria-label="Menu"
        >
          {props.leftIcon}
        </IconButton>
        <Typography variant="title" color="inherit" noWrap className={classes.title}>
          {props.title}
        </Typography>

        <IconButton
          onClick={props.onRightButtonClick}
          className={classes.rightIcon}
          color="inherit"
          aria-label="Menu"
        >
          {props.rightIcon}
        </IconButton>
      </Toolbar>
    </AppBar>
  );
}

AppBarComponent.propTypes = {
  classes: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  onRightButtonClick: PropTypes.func,
  onLeftButtonClick: PropTypes.func,
  leftIcon: PropTypes.object,
  rightIcon: PropTypes.object
};

export default withStyles(styles)(AppBarComponent);


// WEBPACK FOOTER //
// ./src/components/app-bar.js